import { render, staticRenderFns } from "./form-sign-up-default.vue?vue&type=template&id=2d1464cd&"
import script from "./form-sign-up-default.vue?vue&type=script&lang=js&"
export * from "./form-sign-up-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports